/** biome-ignore-all lint/suspicious/noExplicitAny: keep component generic */
import { memo, type PropsWithChildren } from 'react';

export type Data = Record<string, any>[];

export interface LabelKeyObject {
    label: string;
    key: string;
}
export type Headers = LabelKeyObject[] | string[];

const isLabelKeyObject = (data: unknown[]): data is LabelKeyObject[] => {
    return data.length > 0 && typeof data[0] === 'object' && data[0] !== null && 'label' in data[0];
};

export const ExportCSV = memo(
    ({
        data,
        fileName,
        headers,
        iconOnlyButton,
        children,
    }: PropsWithChildren<{ data: Data; headers: Headers; fileName?: string; iconOnlyButton?: boolean }>) => {
        const downloadCSV = () => {
            let labels: string[];
            let keys: string[];
            if (isLabelKeyObject(headers)) {
                labels = headers.map(it => `"${it.label}"`);
                keys = headers.map(it => it.key);
            } else {
                labels = headers.map(it => `"${it}"`);
                keys = headers;
            }
            // Convert the data array into a CSV string
            const csvString = [
                labels, // Specify your headers here
                ...data.map(item => keys.map(key => `"${item[key]}"`)), // Map your data fields accordingly
            ]
                .map(row => row.join(','))
                .join('\n');

            // Create a Blob from the CSV string
            const blob = new Blob([csvString], { type: 'text/csv' });

            // Generate a download link and initiate the download
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || 'download.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        };

        return (
            <button
                className={`btn btn-primary${iconOnlyButton ? ' btn-icon-only' : ''}`}
                type={'button'}
                onClick={downloadCSV}
            >
                {children}
            </button>
        );
    }
);
